import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type LayoutStore = {
    theme: 'dark' | 'light';
    switchTheme: () => void;

    menuCollapsed: boolean;
    toggleMenuCollapsed: () => void;

    menuMobile: boolean;
    toggleMenuMobile: () => void;

    isFullscreen: boolean;
    toggleFullscreen: () => void;

    hideLayout: boolean;
    newVersion: string | null;
};

export const useLayoutStore = create<LayoutStore>()(
    persist(
        // biome-ignore assist/source/useSortedKeys: manual
        (set, get) => ({
            theme: 'light',

            switchTheme() {
                set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' }));
            },

            menuCollapsed: false,

            toggleMenuCollapsed() {
                set((s) => ({ menuCollapsed: !s.menuCollapsed }));
            },

            menuMobile: false,

            toggleMenuMobile() {
                set((s) => ({ menuMobile: !s.menuMobile }));
            },

            isFullscreen: false,

            async toggleFullscreen() {
                // Safari doesn't support requestFullscreen
                // https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullscreen#browser_compatibility
                if (!document.documentElement.requestFullscreen) {
                    return;
                }

                if (get().isFullscreen) {
                    await document.exitFullscreen();
                } else {
                    await document.documentElement.requestFullscreen();
                }
            },

            hideLayout: false,
            newVersion: null,
        }),
        {
            name: 'layout',
            partialize: (state) => ({ theme: state.theme }),
        },
    ),
);
